import React, { MouseEventHandler, useState } from "react";
import styled from "styled-components";
import {
  ButtonProps,
  CheckboxDefault,
  Theme,
} from "@literati/public-ui-shared-react";
import { FormikChildrenRenderProps } from "components/Step/StepLayout";
import { CheckoutDummyAccountLegalCheckbox } from "components/checkout/CheckoutDummyAccountLegalCheckbox";
import AuthFormTextInput from "components/authenticate/AuthFormTextInput";
import AuthFormToggle from "components/authenticate/AuthFormToggle";
import { AuthKey, AuthValues } from "components/authenticate/authTypes";

const CLASS_BASE = "auth-form-section-dummy-account";
export const AuthFormSectionDummyAccountClassName = {
  TERMS_CHECKBOX: `${CLASS_BASE}-terms-checkbox`,
  MAILING_LIST_CHECKBOX: `${CLASS_BASE}-mailing-list-checkbox`,
} as const;

const StyledCheckbox = styled(CheckboxDefault)`
  margin: 1rem 0 0;
  font-size: 0.75rem;
`;

export interface AuthFormSectionDummyAccountProps
  extends FormikChildrenRenderProps<AuthValues> {
  onFormToggleClick?: MouseEventHandler<HTMLButtonElement>;
  submitButtonProps?: ButtonProps;
}

export const AuthFormSectionDummyAccount = ({
  errors,
  onFormToggleClick,
  submitCount,
  touched,
}: AuthFormSectionDummyAccountProps) => {
  const cls = AuthFormSectionDummyAccountClassName;

  const [emailBlurred, setEmailBlurred] = useState(false);

  return (
    <Theme>
      <AuthFormTextInput
        errors={errors}
        hasBlurred={emailBlurred}
        onBlur={() => setEmailBlurred(true)}
        submitCount={submitCount}
        variant="email"
      />
      <CheckoutDummyAccountLegalCheckbox
        className={cls.TERMS_CHECKBOX}
        css="margin: 1.5rem 0 0"
        hasFieldError={Boolean(errors?.[AuthKey.TERMS])}
        touched={touched?.[AuthKey.TERMS]}
      />
      <StyledCheckbox
        className={cls.MAILING_LIST_CHECKBOX}
        label="Yes, I want to get email updates about Literati’s new products, promotions, and bookish fun."
        name="mailingList"
      />
      <AuthFormToggle onClick={onFormToggleClick} variant="createAccount" />
    </Theme>
  );
};

export default AuthFormSectionDummyAccount;
